export default window.matchMedia("(prefers-reduced-motion: reduce)").matches